// extracted by mini-css-extract-plugin
export var productImage = "_ux-0";